import { render, staticRenderFns } from "./TemplatesList.vue?vue&type=template&id=681155ee&scoped=true&"
import script from "./TemplatesList.vue?vue&type=script&lang=js&"
export * from "./TemplatesList.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesList.vue?vue&type=style&index=0&id=681155ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681155ee",
  null
  
)

export default component.exports